import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ReactDOMServer from 'react-dom/server';
import moment from 'moment';
import {espace_mille} from 'app/espace_mille'
import {column_correspondance_facture,recap_correspondance_facture} from '../facturation/correspondance_facture'
import html2canvas from 'html2canvas';
import { getPaysLabel, getCurrentLangFromCookie } from 'app/paysList';
var JsBarcode = require('jsbarcode');

// Listes par défaut si le backend ne renvoie pas encore allInfos.emetteur_client_pdf (rétrocompatibilité)
const DEFAULT_CHAMPS_SOCIETE = ['name','capital','rcs','tva_number','adresse','tel','email','logo'];
const DEFAULT_CHAMPS_CLIENT = ['name','adresse','tel','email','tva_number','siren','siret','adresse_livraison'];

const FacturationNew = async ({t,documentType,companyInfos,billing,clientDetail,devise,digit,allInfos,columnShow,recapShow,moduleFacturation=null}) => {
    const dateNow = new Date();

    // Champs société/client à afficher, paramétrables dans Administration > Facturation > Données Emetteur / Client
    const champsSociete = allInfos?.emetteur_client_pdf?.champs_societe ?? DEFAULT_CHAMPS_SOCIETE;
    const champsClient = allInfos?.emetteur_client_pdf?.champs_client ?? DEFAULT_CHAMPS_CLIENT;
    const showSociete = (champ) => champsSociete.includes(champ);
    const showClient = (champ) => champsClient.includes(champ);

    // Équivalence de devise auto (config compagnie + choix client B2B) : remplace la saisie manuelle en commentaire
    const clientInfosEquivalence = clientDetail.divers || clientDetail.infos || {}
    const equivalenceCode = clientInfosEquivalence.devise_equivalence || null
    const equivalenceConf = equivalenceCode && (companyInfos.advanceparams.equivalences_devises || []).find(d => d.code===equivalenceCode)
    const equivalenceMontant = equivalenceConf ? (+allInfos.ttc / +equivalenceConf.taux) : null

    // Fonction pour ajouter un zéro devant les nombres inférieurs à 10
    const pad = (num) => (num < 10 ? '0' + num : num);

    // Extraire les composants de la date
    const year = dateNow.getFullYear();
    const month = pad(dateNow.getMonth() + 1); // Les mois commencent à 0
    const day = pad(dateNow.getDate());
    const hours = pad(dateNow.getHours());
    const minutes = pad(dateNow.getMinutes());
    const seconds = pad(dateNow.getSeconds());

    const isEmpty = (v) => v === null || v === undefined || v === '';

    const loadImageSafe = async (url) => {
        try {
            const res = await fetch(url);
            if (!res.ok) return null;
            const blob = await res.blob();
            return await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = () => resolve(null);
                reader.readAsDataURL(blob);
            });
        } catch {
            return null;
        }
    };

    const sortedBilling = (allInfos.type != 'billing') ? billing : [...billing].sort((a, b) => {

        const origineA = (a.origin_facture_id ?? '').toString();
        const origineB = (b.origin_facture_id ?? '').toString();

        const groupA = (a.groupValue ?? '').toString();
        const groupB = (b.groupValue ?? '').toString();

        const sortA = (a.sortValue ?? '').toString();
        const sortB = (b.sortValue ?? '').toString();

        // origine vide en premier (mais 0 est considéré comme une valeur valide)
        const emptyOrigineA = isEmpty(origineA);
        const emptyOrigineB = isEmpty(origineB);

        if (emptyOrigineA !== emptyOrigineB) {
            return emptyOrigineA ? -1 : 1;
        }

        // tri par origine
        const cmpOrigine = String(origineA ?? '').localeCompare(
            String(origineB ?? ''),
            undefined,
            { numeric: true, sensitivity: 'base' }
        );
        if (cmpOrigine !== 0) return cmpOrigine;

        // grouping vide en premier (dans chaque origine)
        const emptyGroupA = isEmpty(groupA);
        const emptyGroupB = isEmpty(groupB);

        if (emptyGroupA !== emptyGroupB) {
            return emptyGroupA ? -1 : 1;
        }

        // tri par grouping
        const cmpGroup = String(groupA ?? '').localeCompare(
            String(groupB ?? ''),
            undefined,
            { numeric: true, sensitivity: 'base' }
        );
        if (cmpGroup !== 0) return cmpGroup;

        // sort
        return sortA.localeCompare(sortB, undefined, {
            numeric: true,
            sensitivity: 'base'
        });
    });

    // const sortedBilling = billing

    let baseHt={} // pour calcul de la base HT de chaque taux de tgc car pas enregsitré sur le back et ça doit être préciser sur la facture

    // Formater la date
    const now = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    let logo = process.env.REACT_APP_API_URL+'images/'+companyInfos.logo

    let clientName = (clientDetail!=null && clientDetail.name!=null && clientDetail.firstname!=null) ? clientDetail.name+' '+clientDetail.firstname : (clientDetail!=null && clientDetail.name!=null) ? clientDetail.name : ''
    // let clientCode = (clientDetail.old_code_client!=null) ? clientDetail.old_code_client : 'C'+clientDetail.id
    let clientCode = clientDetail.code_comptable

    let canvas;
    // For Barcode
    canvas = document.createElement('canvas');
    JsBarcode(canvas, allInfos.bar, {
        displayValue: false,
    });
    const barcode = canvas.toDataURL();

    const changeObjetToString = (obj) => {
        obj = ReactDOMServer.renderToStaticMarkup(obj)
        return obj.replace(/<[^>]*>/g, '')
    }

    const convertHtmlToTextBr = (html) => {
        return html.replaceAll('<br />', '').replaceAll('<br>', '');
    };

    const changeObjetDateToString = (obj) => {
        if(obj){
            // Convertir l'objet en HTML statique
            let stringDate = ReactDOMServer.renderToStaticMarkup(obj);
            // Supprimer les balises HTML
            stringDate = stringDate.replace(/<[^>]*>/g, '');
            // Convertir la date en format souhaité
            const formattedDate = moment(stringDate).format("DD/MM/YYYY"); // Par exemple, format jour/mois/année

            return formattedDate;
        }
        
        else return '';
    }

    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: 'a4',
    });

    let yPosition=30
    let xPosition=20
    let margeRight=20
    let pageWidth = doc.internal.pageSize.getWidth();
    let pageHeight = doc.internal.pageSize.getHeight();
    let half = pageWidth/2-margeRight
    let one_tier = pageWidth/3-margeRight
    let textSplit = ''

    // Total nbr article
    let count=0
    allInfos?.facture_article_list?.length > 0 && allInfos.facture_article_list.map(item=>{
        count+=+item.quantity
    })

    doc.setProperties({
        title: allInfos.bar
    });

    // // 1. Header Section
    // Définir la taille et couleur de police
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0); // Couleur du texte
    // Définir la couleur de fond pour la ligne de texte
    doc.setFillColor(234, 234, 234);
    // Dessiner un rectangle qui prend toute la largeur de la page à la hauteur du texte
    const recHeight = (allInfos.dossier_b2b[0]) ? 35 : 25; // Hauteur du rectangle
    // Dessiner le rectangle en fond
    doc.rect(0, yPosition - 17, pageWidth, recHeight, 'F');
    // Ajouter les textes par-dessus le fond
    doc.text((allInfos.status==1) ? t(documentType)+' '+allInfos.bar : t(documentType), xPosition, yPosition);
    doc.text(t('emisLe')+' : '+changeObjetDateToString((allInfos.date_finalisation) ? allInfos.date_finalisation : now), pageWidth - 120, yPosition);
    if(allInfos.dossier_b2b[0]){
        yPosition+=11
        let str_dossier=allInfos.dossier_b2b[0].name;
        if(allInfos.dossier_b2b[1]) str_dossier+=',...'
        doc.text(t('folder')+' '+str_dossier, xPosition, yPosition);
    }

    // // 2. Infos company
    // gauche
    yPosition+=40
    let blocLeftPosition=yPosition;
    if(allInfos.type!='billingBuy' && allInfos.type!='creditNoteBuy'){
        if(companyInfos.name != null && showSociete('name')){
            doc.setFont(undefined, 'bold');
            doc.text(companyInfos.name, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(companyInfos.advanceparams.capital && companyInfos.advanceparams.capital != null && showSociete('capital')){
            doc.setFont(undefined, 'normal');
            doc.text('Capital : '+espace_mille(Math.round(' '+companyInfos.advanceparams.capital),2)+' '+devise, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(companyInfos.rcs != null && showSociete('rcs')) {
            doc.setFont(undefined, 'normal');
            doc.text(companyInfos.nomenclature_rcs+' : '+companyInfos.rcs, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(companyInfos.tva_number != null && showSociete('tva_number')) {
            doc.setFont(undefined, 'normal');
            doc.text(t('numeroTgc', {taxe:companyInfos.nomenclature_tgc})+' : '+companyInfos.tva_number, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        let stradress=''
        let calculRetourCharriot=0;
        if(showSociete('adresse')){
            if((companyInfos.advanceparams.adress && companyInfos.advanceparams.adress != null)) {
                stradress+=companyInfos.advanceparams.adress+' '
                let  theSplit=companyInfos.advanceparams.adress.split('\n');
                calculRetourCharriot=(theSplit.length-1)*15;//pour prise en compte des retours charriot dans le décalage des lignes
            }
            if((companyInfos.advanceparams.ville && companyInfos.advanceparams.ville != null)) stradress+='- '+companyInfos.advanceparams.ville+' '
            if((companyInfos.advanceparams.code_postal && companyInfos.advanceparams.code_postal != null)) stradress+='- '+companyInfos.advanceparams.code_postal+' '
        }
        if(stradress!=''){
            doc.setFont(undefined, 'normal');
            doc.text(stradress, xPosition, blocLeftPosition);
            blocLeftPosition+=11+calculRetourCharriot
        }
        if(companyInfos.tel != null && showSociete('tel')){
            doc.setFont(undefined, 'normal');
            doc.addImage('/assets/images/phone.png', 'PNG', xPosition, blocLeftPosition-9, 10, 10);
            doc.text(companyInfos.tel, xPosition+15, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(companyInfos.email != null && showSociete('email')){
            doc.setFont(undefined, 'normal');
            doc.addImage('/assets/images/email.png', 'PNG', xPosition, blocLeftPosition-9, 10, 10);
            doc.text(companyInfos.email, xPosition+15, blocLeftPosition);
            blocLeftPosition+=11
        }
    }
    else{
        if(clientDetail.name != null){
            doc.setFont(undefined, 'bold');
            doc.text(clientDetail.name, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(clientDetail.tva_number != null) {
            doc.setFont(undefined, 'normal');
            doc.text(t('numeroTgc', {taxe:companyInfos.nomenclature_tgc})+' : '+clientDetail.tva_number, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
    }
    if(allInfos.status==1){
        doc.addImage(barcode, 'PNG', xPosition, blocLeftPosition-10, 150, 20);
        blocLeftPosition+=25
    }
    //right
    let blocRightPosition = yPosition-20
    if(allInfos.type!='billingBuy' && allInfos.type!='creditNoteBuy' && companyInfos.logo && companyInfos.logo != null && showSociete('logo')){
        const logoData = await loadImageSafe(logo);
        if (logoData) {
            doc.addImage(logoData, 'PNG', pageWidth-130, blocRightPosition, 100, 100);
            blocRightPosition+=100
        }
    }

    // // 3. Hr
    yPosition=(blocLeftPosition>blocRightPosition) ? blocLeftPosition : blocRightPosition;
    doc.line(pageWidth/4, yPosition, pageWidth/4*3, yPosition);
    
    // // 4. Client
    yPosition+=15
    blocLeftPosition=yPosition;
    blocRightPosition=yPosition+15;
    if(allInfos.type!='billingBuy' && allInfos.type!='creditNoteBuy'){
        //gauche
        doc.setFont(undefined, 'bold');
        textSplit=doc.splitTextToSize((showClient('name') ? clientName+' - '+clientCode : clientCode), half);
        doc.text(textSplit, xPosition, blocLeftPosition);
        let textDimensions = doc.getTextDimensions(textSplit);
        blocLeftPosition+=textDimensions.h+1

        if(showClient('adresse')){
            if(clientDetail.divers && clientDetail.divers.adresse!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(clientDetail.divers.adresse, half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
            else if(clientDetail.infos && clientDetail.infos.adresse!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(clientDetail.infos.adresse, half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
            if(clientDetail.divers && clientDetail.divers.quartier!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(clientDetail.divers.quartier, half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
            else if(clientDetail.infos && clientDetail.infos.quartier!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(clientDetail.infos.quartier, half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
            if(clientDetail.divers && clientDetail.divers.ville!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(clientDetail.divers.ville, half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
            else if(clientDetail.infos && clientDetail.infos.ville!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(clientDetail.infos.ville, half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
            if(clientDetail.divers && clientDetail.divers.codepostal!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(clientDetail.divers.codepostal, half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
            else if(clientDetail.infos && clientDetail.infos.codepostal!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(clientDetail.infos.codepostal, half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
            if(clientDetail.divers && clientDetail.divers.pays!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(getPaysLabel(clientDetail.divers.pays, getCurrentLangFromCookie()), half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
            else if(clientDetail.infos && clientDetail.infos.pays!=null){
                doc.setFont(undefined, 'normal');
                textSplit=doc.splitTextToSize(getPaysLabel(clientDetail.infos.pays, getCurrentLangFromCookie()), half);
                doc.text(textSplit, xPosition, blocLeftPosition);
                textDimensions = doc.getTextDimensions(textSplit);
                blocLeftPosition+=textDimensions.h+1
            }
        }

        if(clientDetail.tel && showClient('tel')){
            doc.setFont(undefined, 'normal');
            doc.addImage('/assets/images/phone.png', 'PNG', xPosition, blocLeftPosition-9, 10, 10);
            doc.text(clientDetail.tel, xPosition+15, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(clientDetail.email && showClient('email')){
            doc.setFont(undefined, 'normal');
            doc.addImage('/assets/images/email.png', 'PNG', xPosition, blocLeftPosition-9, 10, 10);
            let mails = clientDetail.email.split(/[,;]+/);//au cas où il y ai plus mails écris, on retourne que le premier
            textSplit=doc.splitTextToSize(mails[0].trim(), half);
            doc.text(textSplit, xPosition+15, blocLeftPosition);
            textDimensions = doc.getTextDimensions(textSplit);
            blocLeftPosition+=textDimensions.h+1
        }
        if(clientDetail.infos && clientDetail.infos.tva_number != null && showClient('tva_number')) {
            doc.setFont(undefined, 'normal');
            doc.text(t('numeroTgc', {taxe:companyInfos.nomenclature_tgc})+' : '+clientDetail.infos.tva_number, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(clientDetail.infos && clientDetail.infos.siren != null && showClient('siren')) {
            doc.setFont(undefined, 'normal');
            doc.text(t('siren')+' : '+clientDetail.infos.siren, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(clientDetail.infos && clientDetail.infos.siret != null && showClient('siret')) {
            doc.setFont(undefined, 'normal');
            doc.text(t('siret')+' : '+clientDetail.infos.siret, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(allInfos.mode_paiement_default != null) {
            doc.setFont(undefined, 'normal');
            doc.text(t('modePay')+' : '+((t(allInfos.mode_paiement_default))?t(allInfos.mode_paiement_default):allInfos.mode_paiement_default), xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }

        // //droite
        if(clientDetail.infos && clientDetail.infos.adresse_livraison!=null && showClient('adresse_livraison')){//adresse de livraison
            //label
            doc.setFont(undefined, 'bold');
            textSplit=doc.splitTextToSize(t('labelAdressLivraison')+':', half);
            doc.text(textSplit, pageWidth/2, blocRightPosition);
            let textDimensions = doc.getTextDimensions(textSplit);
            blocRightPosition+=textDimensions.h+1

            //contenu
            doc.setFont(undefined, 'normal');
            textSplit=doc.splitTextToSize(clientDetail.infos.adresse_livraison, half);
            doc.text(textSplit, pageWidth/2, blocRightPosition);
            textDimensions = doc.getTextDimensions(textSplit);
            blocRightPosition+=textDimensions.h+1
        }
    }
    else{
        doc.setFont(undefined, 'bold');
        if(companyInfos.name != null){
            doc.setFont(undefined, 'bold');
            doc.text(companyInfos.name, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        if(companyInfos.tva_number != null) {
            doc.setFont(undefined, 'normal');
            doc.text(t('numeroTgc', {taxe:companyInfos.nomenclature_tgc})+' : '+companyInfos.tva_number, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
        let stradress=''
        if((companyInfos.advanceparams.adress && companyInfos.advanceparams.adress != null)) stradress+=companyInfos.advanceparams.adress+' '
        if((companyInfos.advanceparams.ville && companyInfos.advanceparams.ville != null)) stradress+='- '+companyInfos.advanceparams.ville+' '
        if((companyInfos.advanceparams.code_postal && companyInfos.advanceparams.code_postal != null)) stradress+='- '+companyInfos.advanceparams.code_postal+' '
        if(stradress!=''){
            doc.setFont(undefined, 'normal');
            doc.text(stradress, xPosition, blocLeftPosition);
            blocLeftPosition+=11
        }
    }

    // // 5. Text Supérieur
    yPosition=(blocLeftPosition>blocRightPosition) ? blocLeftPosition : blocRightPosition;
    if(allInfos.divers_infos!=null && allInfos.divers_infos.hasOwnProperty('superieur_infos') && allInfos.divers_infos.superieur_infos!=null && allInfos.divers_infos.superieur_infos!=''){
        var tempContainerHaut = document.createElement('div');
        tempContainerHaut.innerHTML = allInfos.divers_infos.superieur_infos;
        tempContainerHaut.style.fontSize = (allInfos.divers_infos.superieur_infos_size!=null)?String(allInfos.divers_infos.superieur_infos_size)+'px':'10px';
        tempContainerHaut.style.color = '#000';
        tempContainerHaut.style.whiteSpace = 'normal';
        tempContainerHaut.style.wordBreak = 'normal';
        tempContainerHaut.style.width = '550px';
        tempContainerHaut.style.position = 'absolute'; // Hors de la vue

        // Ajouter temporairement le conteneur au DOM
        document.body.appendChild(tempContainerHaut);

        // Récupérer la hauteur du contenu
        var contentHeightHaut = tempContainerHaut.offsetHeight;

        // Utiliser html2canvas pour capturer le contenu en tant qu'image
        const canvas = await html2canvas(tempContainerHaut, { scale: 2 }); // scale augmente la résolution de l'image
        const imgData = canvas.toDataURL('image/jpeg',0.6);

        // Retirer le conteneur du DOM après capture
        document.body.removeChild(tempContainerHaut);

        // Définir la page où vous voulez ajouter l'image dans le PDF
        const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
        doc.setPage(currentPage);

        // Ajouter l'image dans le PDF à la position souhaitée
        const imgWidth = 550; // largeur de l'image dans le PDF, ajustez selon vos besoins
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // ajustement proportionnel de la hauteur
        doc.addImage(imgData, 'PNG', xPosition, yPosition, imgWidth, imgHeight);

        yPosition += contentHeightHaut;
    }
    
    // // 6. Datatble
    var tableHeaders = []
    var columnStyle = {}
    if(allInfos.type!='billingDeposit'){
        tableHeaders = columnShow.map(value=>{
            if(column_correspondance_facture[value].name=='tgc'){
                return t(column_correspondance_facture[value].name, {taxe:companyInfos.nomenclature_tgc})
            }else{
                return t(column_correspondance_facture[value].name)
            }
        })
        columnShow.map((value,ind)=>{
            switch(column_correspondance_facture[value].format) {
                case 'designation':
                    return columnStyle[ind]={}
                case 'price':
                    return columnStyle[ind]={cellWidth: 'wrap',halign : 'right'}
                case 'devise':
                    return columnStyle[ind]={cellWidth: 'wrap',halign : 'right'}
                case 'remise':
                    return columnStyle[ind]={cellWidth: 'wrap',halign : 'right'}
                case 'tgc':
                    return columnStyle[ind]={cellWidth: 'wrap',halign : 'right'}
                default:
                    return columnStyle[ind]={halign : 'right'}
            }
        })

        let lastOrigineId = null
        let lastGroup = ''
        const body = [];
        sortedBilling.forEach((value) => { // construit le body en ajoutant les origines quand necessaire
            const originId = value.origin_facture_id ?? null;
            const group = value.groupValue ?? null;

            // on ne met un header que si originId existe
            if (allInfos.type=='billing' && originId && originId !== lastOrigineId && !allInfos.inter_societe) {
                lastOrigineId = originId;
                lastGroup = ''

                // Libellé
                let origineLabel = ''
                if (value.origin_facture.bar.slice(0,3)==='DEV') {
                    origineLabel = `${value.origin_facture.bar} |||`
                }
                else {
                    // Montant réellement facturé pour ce BL (remise déduite), et non le HT brut du BL d'origine
                    const htFactureOrigine = billing
                        .filter((ligne) => ligne.origin_facture_id === originId)
                        .reduce((total, ligne) => total + (+ligne.ht_remise || 0), 0)
                    origineLabel = `${value.origin_facture.bar} ||| ${htFactureOrigine}`
                }

                // On crée une ligne avec 1ère cellule texte, le reste vide
                const headerRow = columnShow.map((_, idx) => (idx === 0 ? origineLabel : ''));

                // On marque cette row pour le style
                headerRow.__isOrigineHeader = true;

                body.push(headerRow);
            }

            // on ne met un header que si group existe
            if (allInfos.type!='billingDeposit' && group && group !== lastGroup) {
                lastGroup = group;

                // Libellé
                const groupLabel = `${value.groupValue}`

                // On crée une ligne avec 1ère cellule texte, le reste vide
                const headerRow = columnShow.map((_, idx) => (idx === 0 ? groupLabel : ''));

                // On marque cette row pour le style
                headerRow.__isGroupingHeader = true;

                body.push(headerRow);
            }


            if (baseHt[value.tgc]) baseHt[value.tgc] += value.ht_remise;
            else baseHt[value.tgc] = value.ht_remise;

            const row = columnShow.map((valeur) => {
                switch(column_correspondance_facture[valeur].format) {
                    case 'designation':
                        let designationText=value[valeur]
                        if(value.description != null && value.description != '' && value.ecotaxe != null && value.ecotaxe != '' && +value.ecotaxe > 0) designationText+='\n'+t('dont')+' '+t('ecotaxe').toLowerCase()+': '+espace_mille(Math.abs(value.ecotaxe),2)+devise+'\n__I__'+convertHtmlToTextBr(value.description)
                        else if(value.ecotaxe != null && value.ecotaxe != '' && +value.ecotaxe > 0) designationText+='\n'+t('dont')+' '+t('ecotaxe').toLowerCase()+': '+espace_mille(Math.abs(value.ecotaxe),2)+devise
                        else if(value.description != null && value.description != '') designationText+='\n__I__'+convertHtmlToTextBr(value.description)
                        return designationText
                    case 'price':
                        let price = +value[valeur]
                        let text = ''
                        if (valeur!='price_unit') text = espace_mille(price,2)+' '+devise
                        else text = (value[valeur]!==null) ? espace_mille(price,2)+' '+devise+((value.article.unit)?`/${value.article.unit??''}` : '') : ''
                        return text
                    case 'devise':
                        let deviseNbr = +value[valeur]
                        let deviseInfo = allInfos.devise!=null ? allInfos.devise : ''
                        return espace_mille(deviseNbr,2)+' '+deviseInfo
                    case 'remise':
                        let remise = +value[valeur]
                        return '-'+espace_mille(remise,2)+' '+devise
                    case 'tgc':
                        if(allInfos.tgc && !Array.isArray(allInfos.tgc)){
                            return value[valeur]+'%'
                        }
                        else{
                            return 0+'%'
                        }
                    default:
                        if (valeur=='unit') return value.article?.[valeur]??''
                        else if (valeur=='weight') return value.article ? `${value.article[valeur]??''} ${value.article.unit??''}` : ''
                        else return value[valeur]
                }
            });

            body.push(row);
        });

        const designationColIndex = columnShow.findIndex(
            (v) => column_correspondance_facture[v]?.format === 'designation'
        );

        doc.autoTable({
            startY: yPosition,
            head: [tableHeaders],
            body: body,
            styles: { fontSize: 8, cellPadding: 4 },
            headStyles: { fontSize: 8, fillColor: [242, 242, 242], textColor: 20, fontStyle: 'bold', halign:'center' },
            margin: { left: 20, right: 20 },
            columnStyles: columnStyle,
            rowPageBreak: 'avoid',
            didParseCell: function (data) {
                if (data.row.raw && data.row.raw.__isOrigineHeader) {
                    data.cell.styles.fillColor = [230, 230, 230];
                    data.cell.styles.textColor = 20;
                    data.cell.styles.fontStyle = 'bold';

                    data.cell.text = String(data.cell.raw ?? '');
                    return;
                }
                if (data.row.raw && data.row.raw.__isGroupingHeader) {
                    data.cell.styles.fillColor = [230, 230, 230];
                    data.cell.styles.textColor = 20;

                    data.cell.text = String(data.cell.raw ?? '');
                    return;
                }
            },
            // Empêche le rendu par défaut UNIQUEMENT pour nos cellules custom
            willDrawCell: function (data) {
                if (data.row.raw && data.row.raw.__isOrigineHeader) {
                    data.cell.text = [];
                    return;
                }

                if (data.row.raw && data.row.raw.__isGroupingHeader) {
                    data.cell.text = [];
                    return;
                }

                if (data.section === 'body' && data.column.index === designationColIndex) {
                    // autoTable a déjà fait le wrap => data.cell.text est souvent un array
                    const lines = Array.isArray(data.cell.text) ? data.cell.text : [String(data.cell.text ?? '')];

                    if (lines.some(l => String(l).includes('__I__'))) {
                    data.cell._wrappedLines = lines.map(String);
                    data.cell.text = []; // on dessine nous-mêmes
                    }
                }
            },
            didDrawCell: function (data) {
                // --- ton header custom inchangé ---
                if (data.row.raw && data.row.raw.__isOrigineHeader && data.column.index === 0) {
                    const raw = data.row.raw[0];
                    const [bar, ht] = String(raw).split('|||');

                    const x = data.cell.x + data.cell.padding('left');
                    const y = data.cell.textPos?.y ?? (data.cell.y + data.cell.padding('top') + data.cell.styles.fontSize);

                    doc.setFont(undefined, 'bold');
                    doc.setTextColor(20);
                    doc.text(bar.trim() + ' ', x, y);

                    const barWidth = doc.getTextWidth(bar.trim() + '   ');
                    doc.setFont(undefined, 'italic');
                    doc.setTextColor(100);
                    doc.text((ht!=='')?(espace_mille(ht,2)+' '+devise ?? '').trim():'', x + barWidth, y);

                    doc.setFont(undefined, 'normal');
                    doc.setTextColor(20);
                    return;
                }

                if (data.row.raw && data.row.raw.__isGroupingHeader && data.column.index === 0) {
                    const raw = data.row.raw[0];
                    const bar = String(raw);

                    const x = data.cell.x + data.cell.padding('left');
                    const y = data.cell.textPos?.y ?? (data.cell.y + data.cell.padding('top') + data.cell.styles.fontSize);

                    doc.setFont(undefined, 'italic');
                    doc.setTextColor(50);
                    doc.text(bar.trim(), x, y);

                    doc.setFont(undefined, 'normal');
                    doc.setTextColor(20);
                    return;
                }

                // --- designation italique ---
                if (data.section === 'body' && data.column.index === designationColIndex && data.cell._wrappedLines) {
                    const d = data.doc;

                    const padL = data.cell.padding('left');
                    const padT = data.cell.padding('top');
                    const x = data.cell.x + padL;

                    const fontSize = data.cell.styles.fontSize || 8;
                    const lhf = data.cell.styles.lineHeightFactor || 1.15;
                    const lineHeight = (fontSize * lhf) / d.internal.scaleFactor;

                    // baseline
                    let y = data.cell.y + padT + (fontSize / d.internal.scaleFactor) * 0.75;

                    const lines = data.cell._wrappedLines;
                    const markerIndex = lines.findIndex(l => l.includes('__I__'));

                    let normalLines = lines;
                    let italicLines = [];

                    if (markerIndex !== -1) {
                    normalLines = lines.slice(0, markerIndex);

                    // la première ligne italic contient peut-être du texte AVANT/APRÈS le marqueur
                    const firstItalic = lines[markerIndex].replace('__I__', '').trim();
                    italicLines = [firstItalic, ...lines.slice(markerIndex + 1)].filter(l => l.trim() !== '');
                    }

                    d.setFontSize(fontSize);

                    // normal
                    d.setFont(undefined, 'normal');
                    d.setTextColor(20);
                    for (const line of normalLines) {
                    if (line.trim() === '') { y += lineHeight; continue; }
                    d.text(line, x, y);
                    y += lineHeight;
                    }

                    // petit espace avant italic (sans \n\n)
                    y += lineHeight * 0.1;

                    // italic
                    d.setFont(undefined, 'italic');
                    d.setTextColor(80);
                    for (const line of italicLines) {
                    if (line.trim() === '') { y += lineHeight; continue; }
                    d.text(line, x, y);
                    y += lineHeight;
                    }

                    d.setFont(undefined, 'normal');
                    d.setTextColor(20);
                }
            }
        });

        yPosition = doc.lastAutoTable.finalY;
    }

    // // 7.Paiement records
    //right
    let blocRightStartPosition=yPosition
    blocRightPosition=yPosition

    let startTableInfo = null;
    let endTableInfo = null;

    let recapFirstPage = null;
    let recapLastPage = null;

    if(allInfos.type!='billingDeposit'){
        startTableInfo = {
            page: doc.internal.getCurrentPageInfo().pageNumber,
            y: blocRightPosition
        }
        doc.autoTable({
            startY: blocRightPosition,
            body: recapShow.flatMap(value => {
                switch (recap_correspondance_facture[value].format) {
                    case 'price':
                        let priceRows = [
                            [t(recap_correspondance_facture[value].name),  // Colonne Détail
                            '',
                            espace_mille(+allInfos[value],2) + ' ' + devise] // Colonne Montant
                        ];
                        // Équivalence de devise auto (config compagnie + choix client B2B) : affichée en italique juste sous le Total TTC
                        if (value=='ttc' && equivalenceMontant!==null) {
                            priceRows.push([
                                {content: t('totalEquivalenceDevise',{devise:equivalenceCode}), styles:{fontStyle:'italic', fontSize:7}},
                                '',
                                {content: espace_mille(equivalenceMontant,2) + ' ' + equivalenceCode, styles:{fontStyle:'italic', fontSize:7}}
                            ]);
                        }
                        return priceRows;
                    case 'devise':
                        let deviseInfo = allInfos.devise!=null ? allInfos.devise : ''
                        return [
                            [t(recap_correspondance_facture[value].name),
                            '',
                            espace_mille(+allInfos[value],2) + ' ' +deviseInfo]
                        ];
                    case 'remise':
                        return [
                            [t(recap_correspondance_facture[value].name), 
                            '',
                            '-' + espace_mille(+allInfos[value],2) + ' ' + devise]
                        ];
                    case 'tgc':
                        if (allInfos.tgc && !Array.isArray(allInfos.tgc)) {
                            return Object.entries(allInfos.tgc).map(([key, valeur]) => [
                                companyInfos.nomenclature_tgc+' ' + key + '%', 
                                'Base HT: ' + (baseHt[key] ? espace_mille(baseHt[key],2) + ' ' + devise : ''),
                                espace_mille(valeur,2) + ' ' + devise
                            ]);
                        } else {
                            return [];  // Retourner un tableau vide si aucune entrée TGC
                        }
                    default:
                        return [];  // Toujours retourner un tableau
                }
            }),
            styles: { fontSize: 8, cellPadding: 4},
            margin: { left: pageWidth/3+50, right: 20 },
            columnStyles: {
                0: {fontStyle: 'bold'},
                1: {},
                2: {halign: 'right'}
            },
            rowPageBreak: 'avoid'
        });
        // doc.lastAutoTable.pageNumber N'EST PAS un numéro de page absolu du document : c'est relatif au
        // nombre de pages parcourues PAR ce tableau (ex: 1 si le tableau tient sur une seule page, même si
        // cette page est en réalité la page 2 ou 3 du document). L'utiliser comme numéro de page absolu faisait
        // reculer le curseur vers une mauvaise page (ex: retour en page 1 alors que le récap est en page 2),
        // d'où le chevauchement avec l'en-tête. La page absolue réelle est celle où le document se trouve
        // juste après l'appel à autoTable, avant tout doc.setPage().
        const realRecapPage = doc.internal.getCurrentPageInfo().pageNumber;
        endTableInfo = {
            page: realRecapPage,
            y: doc.lastAutoTable.finalY
        }
        blocRightStartPosition = blocRightPosition;
        blocRightPosition = doc.lastAutoTable.finalY;
        recapFirstPage = realRecapPage;
        recapLastPage = realRecapPage;
        doc.setPage(recapFirstPage)
    }
    // left
    doc.setFontSize(8);
    // Si le tableau récap (Total/TVA) n'a pas pu tenir à la suite des articles et a démarré sur une nouvelle
    // page, blocRightStartPosition (position en bas de l'ancienne page) n'a plus de sens sur cette nouvelle
    // page : on repart d'une marge haute, sinon le bloc de gauche se retrouve hors-page ou sur le pied de page.
    if(startTableInfo!=null && recapFirstPage!=null && recapFirstPage!=startTableInfo.page){
        blocLeftPosition=30;
    }else{
        blocLeftPosition=blocRightStartPosition+25;
    }
    //pour affichage limite règlement et règlement facture, facture d'achat et facture d'acompte
    if(allInfos.facture_paiement_records.length!=0){
        // Estimation de la hauteur nécessaire (libellé + une ligne par règlement) pour éviter que ce bloc
        // ne soit dessiné trop bas et ne chevauche le bas de page (texte superposé constaté sur certaines factures)
        let neededHeightPerRecord = (allInfos.type=='billingDeposit') ? 25 : 15;
        let neededHeight = 15 + allInfos.facture_paiement_records.length*neededHeightPerRecord;
        if(blocLeftPosition+neededHeight > pageHeight-40){
            doc.addPage();
            blocLeftPosition=30;
            recapLastPage=doc.internal.getCurrentPageInfo().pageNumber; // pour que la suite (total articles, signature, pied de page) reprenne bien sur cette nouvelle page
        }
        if(allInfos.type!='billingDeposit'){
            doc.setFont(undefined, 'bold');
            doc.text(t('payment')+':', xPosition, blocLeftPosition);
            blocLeftPosition+=15
            allInfos.facture_paiement_records.map(value=>{
                let modePay = (t(value.mode)) ? t(value.mode) : value.mode
                doc.setFont(undefined, 'normal');
                doc.text(modePay+' - '+changeObjetDateToString(value.paiement_date)+' - '+espace_mille(+value.montant,2)+' '+devise, xPosition, blocLeftPosition);
                blocLeftPosition+=15
            })
        }
        else{
            doc.setFont(undefined, 'bold');
            doc.setFontSize(10);
            doc.text(t('depositLabel')+' '+t(allInfos.link_with_parent.type)+' - '+allInfos.link_with_parent.bar+' :', xPosition, blocLeftPosition);
            blocLeftPosition+=15
            allInfos.facture_paiement_records.map(value=>{
                let modePay = (t(value.mode)) ? t(value.mode) : value.mode
                doc.setFont(undefined, 'normal');
                doc.text(modePay+' - '+changeObjetDateToString(value.paiement_date)+' - '+espace_mille(+value.montant,2)+' '+devise, xPosition, blocLeftPosition);
                blocLeftPosition+=15
            })
            doc.setFontSize(8);
            doc.setTextColor(0, 0, 0);
        }
    }
    else if((allInfos.type=='billing' || allInfos.type=='billingDeposit' || allInfos.type=='billingBuy') && allInfos.date_limit){
        // Estimation de la hauteur nécessaire (ligne de date limite + éventuel texte de pénalité de retard)
        // pour éviter que ce bloc ne soit dessiné trop bas et ne chevauche le pied de page (constaté sur certaines factures)
        let neededHeight = 15;
        if(documentType=='billing' && allInfos.infos_date_limit!=null){
            let caseLatePaymentText = doc.splitTextToSize(t('caseLatePayment')+' : '+allInfos.infos_date_limit, one_tier);
            neededHeight += doc.getTextDimensions(caseLatePaymentText).h;
        }
        if(blocLeftPosition+neededHeight > pageHeight-40){
            doc.addPage();
            blocLeftPosition=30;
            recapLastPage=doc.internal.getCurrentPageInfo().pageNumber; // pour que la suite (total articles, signature, pied de page) reprenne bien sur cette nouvelle page
        }
        doc.setFont(undefined, 'bold');
        doc.setFontSize(10);
        doc.setTextColor(200, 50, 50);
        let intitule_limit_paiement=t('limitDayPayment')+' : '
        doc.text(intitule_limit_paiement+' '+changeObjetDateToString(allInfos.date_limit), xPosition, blocLeftPosition);
        blocLeftPosition+=15
        doc.setFont(undefined, 'normal');
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        if(documentType=='billing' && allInfos.infos_date_limit!=null){
            doc.setFont(undefined, 'normal');
            doc.setTextColor(0, 0, 0);
            doc.text(t('caseLatePayment')+' : '+allInfos.infos_date_limit, xPosition, blocLeftPosition,{ maxWidth: one_tier });
        }
    }
    //pour affichage limite validité et versment d'acompte pour devis et bon de commande
    if((allInfos.type=='quotation' || allInfos.type=='purchaseOrderB2b') && allInfos.link_with_child!=null && allInfos.link_with_child.length!=0 && allInfos.link_with_child.filter(value=>value.type=='billingDeposit').length!=0){
        doc.setFont(undefined, 'bold');
        doc.text(t('depositLabel')+':', xPosition, blocLeftPosition);
        blocLeftPosition+=15
        allInfos.link_with_child.map(value=>{
            if(value.type=='billingDeposit'){
                doc.setFont(undefined, 'normal');
                let modePay = (t(value.facture_paiement_records[0].mode)) ? t(value.facture_paiement_records[0].mode) : value.facture_paiement_records[0].mode
                doc.text(modePay+' - '+changeObjetDateToString(value.facture_paiement_records[0].paiement_date)+' - '+espace_mille(+value.facture_paiement_records[0].montant,2)+' '+devise, xPosition, blocLeftPosition);
                blocLeftPosition+=10
                doc.text(t('linkTo')+' '+t('billingDeposit').toLowerCase()+' : '+value.bar, xPosition, blocLeftPosition);
                blocLeftPosition+=15
            }
        })
    }
    if(allInfos.type=='quotation' && allInfos.date_limit){
        doc.setFont(undefined, 'bold');
        doc.setFontSize(10);
        doc.setTextColor(200, 50, 50);
        let intitule_limit_paiement=t('limitDateValidity')+' : '
        doc.text(intitule_limit_paiement+' '+changeObjetDateToString(allInfos.date_limit), xPosition, blocLeftPosition);
        blocLeftPosition+=15
        doc.setFont(undefined, 'normal');
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
    }
    doc.setPage(recapLastPage)

    // Total nbr article
    if (moduleFacturation && moduleFacturation.params?.facture?.params?.nbr_article) {
        if (recapLastPage > recapFirstPage) yPosition=blocRightPosition;
        else yPosition=(blocLeftPosition>blocRightPosition) ? blocLeftPosition : blocRightPosition;
        yPosition+=25
        
        let nbr_article = ('Nbr ' + t('items') + ': ' + Math.round(count*100)/100).replace(/<[^>]*>/g, '')
        doc.setFontSize(8);
        doc.setFont(undefined, 'bold');
        doc.text(nbr_article, pageWidth-70-nbr_article.length, yPosition);
        blocRightPosition=yPosition
    }

    // 8. Text Inférieur
    if (moduleFacturation && moduleFacturation.params?.facture?.params?.nbr_article) {
        yPosition=blocRightPosition
    }
    else {
        if (recapLastPage > recapFirstPage) yPosition=blocRightPosition;
        else yPosition=(blocLeftPosition>blocRightPosition) ? blocLeftPosition : blocRightPosition;
    }
    yPosition+=10
    if(allInfos.divers_infos!=null && allInfos.divers_infos.hasOwnProperty('inferieur_infos') && allInfos.divers_infos.inferieur_infos!=null && allInfos.divers_infos.inferieur_infos!=''){
        var tempContainerBas = document.createElement('div');
        tempContainerBas.innerHTML = allInfos.divers_infos.inferieur_infos;
        tempContainerBas.style.fontSize = (allInfos.divers_infos.inferieur_infos_size!=null)?String(allInfos.divers_infos.inferieur_infos_size)+'px':'9px';
        tempContainerBas.style.color = '#000';
        tempContainerBas.style.whiteSpace = 'normal';
        tempContainerBas.style.wordBreak = 'normal';
        tempContainerBas.style.width = '550px';
        tempContainerBas.style.position = 'absolute'; // Hors de la vue

        // Ajouter temporairement le conteneur au DOM
        document.body.appendChild(tempContainerBas);

        // Utiliser html2canvas pour capturer le contenu en tant qu'image
        const canvas = await html2canvas(tempContainerBas, { scale: 2 }); // scale augmente la résolution de l'image
        const imgData = canvas.toDataURL('image/jpeg',0.6);

         // Récupérer la hauteur du contenu
        var contentHeightBas = tempContainerBas.offsetHeight;

        // Retirer le conteneur du DOM après capture
        document.body.removeChild(tempContainerBas);

        // Définir la page où vous voulez ajouter l'image dans le PDF
        const imgWidth = 550; // largeur de l'image dans le PDF, ajustez selon vos besoins
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // ajustement proportionnel de la hauteur

        let available_height = pageHeight - 30 - yPosition
        if (available_height >= imgHeight) {
            const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
            doc.setPage(currentPage);
        }
        else {
            doc.addPage();
            yPosition = 30;
        }

        // Ajouter l'image dans le PDF à la position souhaitée
        doc.addImage(imgData, 'PNG', xPosition, yPosition, imgWidth, imgHeight);

        yPosition += contentHeightBas;
    }

    // // 8. Signature
    if(allInfos.signature!=null){
        doc.addImage(allInfos.signature, 'PNG', pageWidth/2, yPosition, 250,125);
    }

    // // 9. Footer Section
    const pageCount = doc.internal.getNumberOfPages();
    doc.setFont(undefined, 'normal');
    doc.setFontSize(8);
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        let positionCompteBanque=20;
        if(companyInfos.advanceparams.code_banque != null && companyInfos.advanceparams.code_guichet != null && companyInfos.advanceparams.numero_compte != null && companyInfos.advanceparams.cle_rib != null){
            let ncompte=t('labelNumeroDeCompte')+' : '+companyInfos.advanceparams.code_banque+' '+companyInfos.advanceparams.code_guichet+' '+companyInfos.advanceparams.numero_compte+' '+companyInfos.advanceparams.cle_rib
            let ncompteWidth = doc.getTextWidth(ncompte)
            doc.text(ncompte, (pageWidth - ncompteWidth) / 2, doc.internal.pageSize.height - positionCompteBanque);
            positionCompteBanque=10;
        }
        if(companyInfos.advanceparams.iban){
            let ncompte='IBAN : '+companyInfos.advanceparams.iban
            if(companyInfos.advanceparams.bic) ncompte+=' / BIC: '+companyInfos.advanceparams.bic
            let ncompteWidth = doc.getTextWidth(ncompte)
            doc.text(ncompte, (pageWidth - ncompteWidth) / 2, doc.internal.pageSize.height - positionCompteBanque);
        }
        doc.text(`${i} / ${pageCount}`, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 20);
        doc.text('Généré par freebird', 40, doc.internal.pageSize.height - 20);
    }
    
    return doc.output("blob");
};

export default FacturationNew;